import { Directive, Output, EventEmitter, ElementRef, OnDestroy, HostListener } from '@angular/core'

export interface WindowResizedType {
    width: number
    height: number
}

@Directive({
    standalone: true,
    selector: '[windowResized]',
})
export class FmWindowResizedDirective implements OnDestroy {
    @Output()
    public windowResized = new EventEmitter<WindowResizedType>()

    constructor(private elementRef: ElementRef) {
        this.windowResized.emit({
            width: this.elementRef.nativeElement.offsetWidth,
            height: this.elementRef.nativeElement.offsetHeight,
        })
    }

    @HostListener('window:resize', ['$event']) onResize(event) {
        this.windowResized.emit({
            width: this.elementRef.nativeElement.offsetWidth,
            height: this.elementRef.nativeElement.offsetHeight,
        })
    }

    ngOnInit() {}

    ngAfterViewInit() {
        setTimeout(() => {
            this.windowResized.emit({
                width: this.elementRef.nativeElement.offsetWidth,
                height: this.elementRef.nativeElement.offsetHeight,
            })
        })
    }

    ngOnDestroy(): void {}
}
